import React from 'react';
import { StyledSignupFlow } from './SignupFlow.styles';

export const LANDING_URL = 'https://tigaly.ai';

/** The page around every signup step: the glow, the logo, and the legal links. */
const SignupFlowShell = ({ variant, children }) => (
  <StyledSignupFlow>
    <div className={`shell${variant ? ` ${variant}` : ''}`}>
      <div className="band" aria-hidden="true" />
      <header className="top">
        <a className="logo" href={LANDING_URL} aria-label="Tigaly AI home">
          <img src="/tigaly-mark.svg" alt="" />
          <span className="wm">
            Tigaly <span>AI</span>
          </span>
        </a>
      </header>
      {children}
      <footer className="foot">
        <span>&copy; {new Date().getFullYear()} Tigaly AI</span>
        <nav aria-label="Legal">
          <a href="/impressum.html">Impressum</a>
          <a href="/terms.html">Terms</a>
        </nav>
      </footer>
    </div>
  </StyledSignupFlow>
);

export default SignupFlowShell;
